import { render, staticRenderFns } from "./scanCode.vue?vue&type=template&id=97ce4a76&scoped=true"
import script from "./scanCode.vue?vue&type=script&lang=js"
export * from "./scanCode.vue?vue&type=script&lang=js"
import style0 from "./scanCode.vue?vue&type=style&index=0&id=97ce4a76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ce4a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ce4a76')) {
      api.createRecord('97ce4a76', component.options)
    } else {
      api.reload('97ce4a76', component.options)
    }
    module.hot.accept("./scanCode.vue?vue&type=template&id=97ce4a76&scoped=true", function () {
      api.rerender('97ce4a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/scanCode.vue"
export default component.exports